import { z } from "zod";

/** `aiCredits.balance` — current credit balance + plan allocation. */
export const aiCreditBalanceOutput = z.object({
  balance: z.number().int(),
  monthlyAllocation: z.number().int(),
  plan: z.string(),
});

/**
 * `aiCredits.transactions` — paginated ledger. `kind` is the unified
 * credit_ledger entry kind (migration 0108); `credits` is the signed amount.
 */
export const aiCreditTransactionSchema = z.object({
  id: z.string().uuid(),
  kind: z.enum([
    "allocation",
    "top_up",
    "reset",
    "usage",
    "reservation",
    "settlement",
    "release",
    "expiry",
    "adjustment",
  ]),
  credits: z.number().int(),
  description: z.string(),
  metadata: z.record(z.unknown()).nullable(),
  createdAt: z.string().datetime(),
});

export const aiCreditTransactionsInput = z.object({
  cursor: z.string().uuid().nullable().default(null),
  limit: z.number().int().min(1).max(50).default(20),
});

export const aiCreditTransactionsOutput = z.object({
  rows: z.array(aiCreditTransactionSchema),
  nextCursor: z.string().uuid().nullable(),
});
